import { render, staticRenderFns } from "./registroorden.vue?vue&type=template&id=1572dc08&"
import script from "./registroorden.vue?vue&type=script&lang=js&"
export * from "./registroorden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports